import { HeadersFunction, LoaderFunctionArgs } from '@remix-run/node';
import { Outlet, ShouldRevalidateFunction, useLoaderData } from '@remix-run/react';
import { GetContentPageDocument } from '@theprintbar/graphql';
import { authenticator } from '@theprintbar/keystone';
import { runSudoGraphql } from '@theprintbar/keystone/context';
import { cachedJsonDay } from '@theprintbar/server';
import { WebRoutes } from '@theprintbar/shared';
import { SimpleCTA } from '@theprintbar/ui';
import { contentMeta } from '~/utils/contentMeta';
import { AuthContainer } from '../components/AuthContainer';

export const meta = contentMeta;

export const headers: HeadersFunction = ({ loaderHeaders }) => ({
	'Cache-Control': loaderHeaders.get('Cache-Control') || '',
});

export async function loader({ request }: LoaderFunctionArgs) {
	await authenticator.isAuthenticated(request, {
		successRedirect: WebRoutes.Account.Landing,
	});
	const { contentPage } = await runSudoGraphql(GetContentPageDocument, { where: { slug: 'create-account' } });

	if (!contentPage) throw new Error('Content page not found');

	return cachedJsonDay({
		contentPage,
	});
}

export default function () {
	const { contentPage } = useLoaderData<typeof loader>();

	return (
		<AuthContainer content={contentPage}>
			<Outlet />
			<SimpleCTA
				content={contentPage}
				containerClassName="mt-8"
				boxClassName="lg:px-10 lg:py-12 bg-bright-blue/20"
				boxBackground="#ECFAED"
				headerClassName="text-lg lg:text-xl"
			/>
		</AuthContainer>
	);
}

//Revalidate if the user is going back to a previous step
export const shouldRevalidate: ShouldRevalidateFunction = ({ formMethod, defaultShouldRevalidate }) => {
	return !formMethod || formMethod === 'GET' || defaultShouldRevalidate;
};
